export default {
    text: 'Content',
    path: '/content',
    icon: 'doc.svg',
    children: [
        {
            text: 'Articles',
            path: '/content/articles',
            children: [],
            permissions: {
                CTEXT: 'READ'
            }
        },
        {
            text: 'Photos',
            path: '/content/photos',
            children: [],
            permissions: {
                CTEXT: 'READ'
            }
        },
        {
            text: 'Playlists',
            path: '/content/playlists',
            children: [],
            permissions: {
                CPLAYLIST: 'READ'
            }
        },
        {
            text: 'Videos',
            path: '/content/videos',
            children: [],
            permissions: {
                CVIDEO: 'READ'
            }
        },
        {
            text: 'Audio',
            path: '/content/audio',
            children: [],
            permissions: {
                CAUDIO: 'READ'
            }
        },
        {
            text: 'Promos',
            path: '/content/promos',
            children: [],
            permissions: {
                CPROMO: 'READ'
            }
        },
        {
            text: 'Documents',
            path: '/content/documents',
            children: [],
            permissions: {
                CDOCUMENT: 'READ'
            }
        },
        {
            text: 'Bios',
            path: '/content/bios',
            children: [],
            permissions: {
                CBIO: 'READ'
            }
        }
    ],
    permissions: {
        CTEXT: 'READ'
    }
};
